import { Divider } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import CustomDrawer from "../../components/drawer/drawer.component";
import PaymentsComponent from "../../components/payments/payments.component";
import "./productpage.styles.scss";

const PaymentsPage = () => {
  let { section } = useParams();

  return (
    <div className="product">
      <CustomDrawer section={"payments"} />
      <Divider orientation="vertical" className="divider" />
      <div className="component">
        <PaymentsComponent />
      </div>
    </div>
  );
};

export default PaymentsPage;
